import script from "./ManagementDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ManagementDashboard.vue?vue&type=style&index=0&id=47af1056&lang=css"

const __exports__ = script;

export default __exports__